$(function() {
	// Main select ID filter

	$(document).on('click', '.variant-button', function(e){
		e.preventDefault();
		$(this).closest('.variant-container').find('.variant-button').removeClass('active');
		$(this).addClass('active');

	});

	$(document).on('filter', '.j-id', function() {
      
		console.log('EVENT FIRED');
      
		$(this).find('option').prop('disabled', true);
		
		var sizeFilter = $(this).data('filtered-size') ? '[data-size=' + $(this).data('filtered-size') + ']' : '';
		
		var colourFilter = $(this).data('filtered-colour') ? '[data-colour=' + $(this).data('filtered-colour') + ']' : '';
		
		$(this).find('option' + colourFilter).prop('disabled', false);

		// $(this).closest('form').find('.j-select-size').addClass('disabled');

		// $(this).find('option[data-sold-out]').prop('disabled', true);

		$(this).find('option' + colourFilter + sizeFilter + ':enabled:first').prop('selected', true);
		
		var selected = $(this).find('option' + colourFilter + sizeFilter + ':enabled:first').prop('selected', true);
		
		$(this).find('option:enabled').each(function() {
			$(this).closest('form').find('.j-select-size[data-size=' + $(this).data('size') + ']').removeClass('disabled');
		});

		$(this).closest('form').find('.j-select-size[data-size='+$(this).find('option:selected').data('size') + ']').addClass('active').parent().siblings().find('a').removeClass('active');
		
		// Get selected option price and update
		var vprice = $(this).find('option:selected').data('price');

		$(this).closest('form').find('.j-update-price').text(vprice);
		// Get selected option compare-at-price and update
		
		var vcompareprice = $(this).find('option:selected').data('compare-at-price');

		$(this).closest('form').find('.j-update-compare-at-price').text(vcompareprice);

		var variant_value = $(this).find('option:selected').val();

		updateSubscriptionInfo(this.closest("form"), variant_value)

		$(this).closest('form').find('.add-to-cart-btn').val(variant_value);

		$('.product_carousel .slick-slide').each(function(i){
			if ($(this).data('variant') == variant_value) {
				var slideIndex = $(this).data('slick-index');
				$('.product_carousel').slick('slickGoTo', slideIndex);
			}
		});
      
        if ($(this).closest('form').find('.j-select-size.disabled').length > 0 && $(this).closest('form').find('.j-select-size').length == $(this).closest('form').find('.j-select-size.disabled').length) {
          // all list items are selected
          //console.log('Disable button');
          $(this).closest('form').find('.add-to-cart-btn').prop('disabled', true);
        } else {
          
          //console.log('Enable button');
          $(this).closest('form').find('.add-to-cart-btn').prop('disabled', false);
			
          
        }
      
      
	})
	// On variant chnage
	$(document).on('click', '.j-select-size, .j-select-colour', function(e) {
		e.preventDefault();
		if($(this).data('size')) {
			// filter by size
			$(this).closest('form').find('.j-id').data('filtered-size', $(this).data('size'));
		}
		if($(this).data('colour')) {
			// filter by colour
			$(this).closest('form').find('.j-id').data('filtered-colour', $(this).data('colour'));
			$(this).closest('form').find('.j-id').data('filtered-size', '');
		}

		$(this).closest('form').find('.j-id').trigger('filter');

		if ($('.j-id').find('option:selected').data('sold-out') == true){
			$(this).closest('form').find('.cta-area').fadeOut();
			$('#OOS-email-capture').fadeIn();
			console.log('reach');
		}else {
			$('.j-id').closest('form').find('.cta-area').fadeIn();
			$('#OOS-email-capture').fadeOut();
			console.log('reach-2');
		}

	});

	// On subscription option changed (One-time / Subsciption)
	$('[name="subscription-option"]').on("change", function(e){
		$(this).closest('form').find('.j-id').trigger('filter');
	})

	// Cart JS functions

	$(document).on('click', '.add-to-cart-btn', function(e){

		e.preventDefault();

		var id 			= $(this).val(); // Get product variant ID from variant
		var quantity 	= $(this).closest('.product-form').find(".j-update-qty").val();
		var product_card 	= $(this).closest('.product-card');
		var subscriptionGroup = $(this).closest('.product-form').find('.subscription-option input:checked').val();
		var plan = $(this).closest('.product-form').find('.frequency option:selected').val();

		console.log (plan, subscriptionGroup)
		// console.log(id);
		// console.log(quantity);


		if(subscriptionGroup) {
			var properties  = { "selling_plan": plan };
		} else {
			var properties = {};
		}

		CartJS.addItem(id, quantity, properties, {
		    "success": function(data, textStatus, jqXHR) {
		        $('.j-toggle-cart').trigger('click');
		        product_card.removeClass('product-options');
		    },
		    "error": function(jqXHR, textStatus, errorThrown) {
		        console.log('Error: ' + errorThrown + '!');
		    }
		});

	});

  
  	if (document.location.href.indexOf('variant=') > -1 ) {		

		function getParameterByName(name, url) {
		    if (!url) url = window.location.href;
		    name = name.replace(/[\[\]]/g, '\\$&');
		    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		        results = regex.exec(url);
		    if (!results) return null;
		    if (!results[2]) return '';
		    return decodeURIComponent(results[2].replace(/\+/g, ' '));
		}

		var variant = getParameterByName('variant').toLowerCase();

		$('.j-select-colour').each(function(){

			if (variant == $(this).data('colour')){

			// setTimeout(function(){
            	$(this).trigger('click');
            	$('.j-select-size:first').trigger('click');
            	console.log('triggered');
            // }, 1000);
				

			}

		});

	} else {
		$('.j-select-size:first, .j-select-colour:first').trigger('click');
		console.log('triggered: else');
	}

	$(document).on('click', '.cart_item .qty-selector span', function(){

		var qty_input = $(this).parent().find('input');

        if( $(this).hasClass('minus') ){

            if( qty_input.val() < 2 ){
                console.log('smaller than 0');
            } else {

                var counter = parseInt(qty_input.val());
                counter--;
              	qty_input.val(counter);

            }

            var itemID = $(this).parent().data('vid');
            console.log('quantity item ID: ' + itemID, 'Quantity: ' + counter);
            
            setTimeout(function(){
            	CartJS.updateItemById(itemID, counter);
            }, 500);

        }

        if( $(this).hasClass('plus') ){

            var counter = parseInt(qty_input.val());
            counter++;
            qty_input.val(counter);

            var itemID = $(this).parent().data('vid');
            console.log('quantity item ID: ' + itemID, 'Quantity: ' + counter);
            
            setTimeout(function(){
            	CartJS.updateItemById(itemID, counter);
            }, 500);

        }  

    });

	$(document).on('click', '.j-remove-product', function(e,cart){
	
		e.preventDefault();
		var vid = $(this).data('vid');
		CartJS.removeItemById(vid);
		$(this).closest('.cart_item').fadeOut();
	
	});

	$('.j-select-colour.active').trigger('click');


    // Open cart on redirect

    if ( document.location.href.indexOf('cart=open') > -1 ) {

    	cartRequestComplete();
        
    }

    $(document).on('click', '.j-add-account-upsell', function(e){
    
    	e.preventDefault();

		var id 			= $(this).data('id'); // Get product variant ID from variant
		var quantity 	= 1;

		// console.log(id);
		// console.log(quantity);

		CartJS.addItem(id, quantity, {}, {
		    "success": function(data, textStatus, jqXHR) {
		        $('.j-toggle-cart').trigger('click');
		    },
		    "error": function(jqXHR, textStatus, errorThrown) {
		        console.log('Error: ' + errorThrown + '!');
		    }
		});
    
    });


	async function updateSubscriptionInfo(form, variantId) {
		let productId, rcWidget, product, variant, planGroup, selectedPlan;
		try {
			productId = parseInt(form.dataset.productid);
			product = await window.ReChargeWidget.api.fetchProduct(productId);
			variant = product.variants.find(x=>x.id==variantId);
			planGroup = product.selling_plan_groups[0];
			
			const selectedPlanName = form.querySelector("select.frequency option:checked").dataset.plan;
			selectedPlan = product.selling_plan_groups[0].selling_plans.find(x => x["selling_plan_name"]==selectedPlanName);

			const discountEl = form.querySelector("[data-subscription-discount]");
			const discountTypeLabel = selectedPlan.price_adjustments_value_type=="percentage"?"%":(" "+selectedPlan.price_adjustments_value_type);
			discountEl.innerHTML = `& Save ` + selectedPlan.price_adjustments_value + discountTypeLabel;
			
			const currencySymbol = Shopify.currency.active == "GBP" ? "£" : Shopify.currency.active;
			Array.from(form.querySelectorAll("[data-one-off-price]")).forEach(el => el.innerHTML = `${currencySymbol}${variant.prices["unit_price"]}`);
			Array.from(form.querySelectorAll("[data-sub-price]")).forEach(el => el.innerHTML = `${currencySymbol}${variant.prices["discounted_price"]}`);
			if (variant.prices["discounted_price"] == variant.prices["unit_price"]) {
				Array.from(form.querySelector(".compare-price")).forEach(el => el.style.display = "hidden");
			} else {
				Array.from(form.querySelector(".compare-price")).forEach(el => el.style.display = null);
			}
			
			// if is subscription, set price on buy button, or whatever price display to the discounted price
			if (form.querySelector("[name='subscription-option']:checked").value) {	
				Array.from(form.querySelectorAll(".j-update-price")).forEach(el => el.innerHTML = `${currencySymbol}${variant.prices["discounted_price"]}`);
			}

		} catch (e) {
			console.error(e)
			if (!productId) return console.error(`Product ID not found in Form:`, form);
			if (!variant) return console.error(`Select variant cannot be found in Recharge widget (var#${variantId})`);
			if (!planGroup) return console.error(`Product have no subscription plan groups (prod#${productId})`);
			if (!selectedPlan) return console.error(`Invalid plan selected (prod#${productId}, ${selectedPlan})`);
		}
	}

	document.addEventListener("recharge:loaded", (e)=>{
		// console.log("Recharge is loaded", e)
		Array.from(document.querySelectorAll("[name='subscription-option']")).forEach(el => {
			$(el).closest('form').find('.j-id').trigger('filter');
		});
	});
});



